import React from 'react';
import { FaRegTrashAlt } from 'react-icons/fa';
import { CartItem } from '../../product/context/ProductContext.tsx';
import { getOptionLabel } from '../../product/ProductType.ts';
import { getWeightLabel } from '../../product/utils.ts';
import { formatPriceWithDots } from '../../utils/utils.ts';

interface Props {
  item: CartItem;
  showDeleteButton?: boolean;
  onDelete?: (productId: string, purchaseOption: string) => void;
}

const getWeightValue = (item: CartItem) =>
  getWeightLabel(
    item.product.boxWeight,
    item.quantity,
    item.purchaseOption as any,
    item.product.productType
  ).replace(/^peso:\s*/i, '');

const CartItemCardMobile: React.FC<Props> = ({
  item,
  showDeleteButton,
  onDelete,
}) => (
  <div className="cart-item-card">
    <p>
      <strong>Producto:</strong> {item.product.name}
    </p>
    <p>
      <strong>Opción:</strong> {getOptionLabel(item.purchaseOption)}
    </p>
    <p>
      <strong>Cantidad:</strong> {item.quantity}
    </p>
    {getWeightValue(item) && (
      <p>
        <strong>Peso:</strong> {getWeightValue(item)}
      </p>
    )}
    <p>
      <strong>Precio unitario:</strong> $
      {formatPriceWithDots(item.partialPrice)}
    </p>
    <p className="cart-item-total">
      <strong>Total:</strong> $
      {formatPriceWithDots(item.partialPrice * item.quantity)}
    </p>
    {showDeleteButton && (
      <button
        className="cart-delete-button"
        onClick={() => onDelete?.(item.product.id, item.purchaseOption)}
      >
        <FaRegTrashAlt />
      </button>
    )}
  </div>
);

export default CartItemCardMobile;
